import resolveUploadUrl from '../../helpers/resolve-upload-url'
import Stamp from '../../types/api/stamp'
import UploadedFile from '../../types/api/uploaded-file'

export interface StampPreview {
    url: string
    file?: UploadedFile
}

export default function getStampPreview(
    stamp: Pick<Stamp, 'image' | 'imageLink'>
): StampPreview | undefined {
    const file = stamp.image?.url ? stamp.image : undefined
    const link = stamp.imageLink?.trim()

    if (link) {
        return { url: link, file }
    }

    if (!file?.url) return undefined

    return { url: resolveUploadUrl(file.url), file }
}
